import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';


class ScheduleGradeAircraftLineAlternateExtra extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      schedule_id: this.props.schedule_id,
      schedule_grade_id: this.props.schedule_grade_id,
      toggled: 0,
      sgas: {},
    };

    //bind específico
    this.deleteCrew = this.deleteCrew.bind(this);
    this.toggleAllSelect = this.toggleAllSelect.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.sgas.staff !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        sgas: newProps.sgas,
        loaded: 1,
      });
    }
  }


  toggleAllSelect() {
    this.setState({
      toggled: 1,
    });
  }
  
  // Remove a aeronave da grade
  deleteCrew(event) {
    var confirm = window.confirm('Tem certeza que deseja remover este tripulante desta escala?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/remover/tripulacao/' + self.props.sgas.sgas_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  

  render() {
    var self = this;
    return (
  <tr>

    <td className="text-center">{self.state.sgas.staff}</td>
    <td className="text-center">{self.state.sgas.inscription}</td>
    <td className="text-center">{self.state.sgas.role}</td>
    {Object.keys(self.props.schedule_days).map(function(k) {
      var day = self.props.schedule_days[k];
      if (typeof self.state.sgas.days !== 'undefined') {
        if (typeof self.state.sgas.days[day.day] !== 'undefined') {
          var style = self.props.initials_colors[self.state.sgas.days[day.day].type_original];
          return(
            <td style={style}>{self.state.sgas.days[day.day].type}</td>
          );
        } else {
          return(
            <td style={{background: 'blue'}}>&nbsp;</td>
          );
        }
        return('');  
      }
    })}

  </tr>
    );
  }
}

export default ScheduleGradeAircraftLineAlternateExtra;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeAircraftLineAlternateExtra.js